<template>
    <!-- <div class="chart" ref="lineChartDiv" :style="`width: ${chartWidth}; height: ${chartHeight}`"></div> -->
    <div class="chart" ref="lineChartDiv" :style="{ width: props.width, height: props.height }"></div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

const lineChartDiv = ref(null);
const props = defineProps({
    chartData: {
        type: Object,
        required: true,
    },
    chartTitle: {
        default: 'difficulty',
    },
    width: { default: '100%' },
    height: { default: '12vw' },
});
let root;
onMounted(() => {
    console.log('props line    : ', props);
    root = am5.Root.new(lineChartDiv.value);
    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([am5themes_Animated.new(root)]);

    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = userAgent.indexOf('android') > -1 || userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1 || userAgent.indexOf('ipod') > -1;

    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    const chart = root.container.children.push(
        am5xy.XYChart.new(root, {
            // panX: true,
            // panY: true,
            // wheelX: 'panX',
            // wheelY: 'zoomX',
            // pinchZoomX: true,
            paddingTop: isMobile ? 30 : 40,
            // paddingLeft: -5,
            //x축 label 짤림
            paddingBottom: 10,
            layout: root.verticalLayout,
            //ex1
            // showTooltipOn: 'always',
            // tooltipText: '6개월 뒤 예상 진도',
            // tooltip: am5.Tooltip.new(root, {}),
            // tooltipX: am5.percent(50),
            // tooltipY: am5.percent(90),
        }),
    );

    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    const xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
            categoryField: 'category',
            // maxDeviation: 0.3,
            // baseInterval: {
            // 	timeUnit: 'month',
            // 	count: 1,
            // },
            renderer: am5xy.AxisRendererX.new(root, {
                // 그리드의 최소간격
                minGridDistance: isMobile ? 10 : 30,
                // x축 색상
                stroke: '#ccc',
                // strokeWidth: 2,
            }),
            // tooltip: am5.Tooltip.new(root, {}),
        }),
    );
    const xRenderer = xAxis.get('renderer');
    xRenderer.grid.template.set('forceHidden', true);

    const yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
            max: 100,
            min: 0,
            // 그리드의 최소간격 (두 그리드 선 사이의 최소 픽셀 거리)
            maxDeviation: 0.3,
            renderer: am5xy.AxisRendererY.new(root, {}),
        }),
    );
    const yRenderer = yAxis.get('renderer');

    // if (isMobile) {
    //     xRenderer.labels.template.setAll({
    //         paddingTop: 12,
    //         fontSize: '.75vw', // x좌표 폰트 크기
    //         fill: '#424242', // x좌표 폰트 색상
    //         fontWeight: 550,
    //     });
    //     yRenderer.labels.template.setAll({
    //         paddingRight: 16,
    //         fontSize: '.85vw', // y좌표 폰트 크기
    //         fill: '#616161', // y좌표 폰트 색상
    //         fontWeight: 550,
    //     });
    // } else {
    xRenderer.labels.template.setAll({
        fontSize: '2.1vmin', // x좌표 폰트 크기
        fill: '#424242', // x좌표 폰트 색상
        paddingTop: 15,
        fontWeight: 550,
        // tooltipX: am5.percent(50),
        // tooltipY: am5.percent(0),
        //ex2
        // tooltipText: '{category}: {value}',
    });
    // x축 label 툴팁
    // xRenderer.labels.template.setup = function (target) {
    //     target.set(
    //         'background',
    //         am5.Rectangle.new(root, {
    //             fill: am5.color(0x000000),
    //             fillOpacity: 0,
    //         }),
    //     );
    // };
    yRenderer.labels.template.setAll({
        paddingRight: 16,
        fontSize: '2vmin', // y좌표 폰트 크기
        fill: '#616161', // y좌표 폰트 색상
        fontWeight: 550,
    });
    // }

    // Add series1(이전 차트)
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    // if (props.chartData[0]?.hasOwnProperty('value1')) {
    const series1 = chart.series.push(
        am5xy.LineSeries.new(root, {
            calculateAggregates: true,
            xAxis: xAxis,
            yAxis: yAxis,
            categoryXField: 'category',
            valueYField: 'value1',
            stroke: '#ccc',
            maskBullets: false,
        }),
    );

    series1.strokes.template.setAll({
        strokeWidth: isMobile ? 2 : 3,
    });
    //툴팁 위한 분기 처리
    if (props.chartTitle == 'kread') {
        series1.bullets.push(function () {
            return am5.Bullet.new(root, {
                sprite: am5.Circle.new(root, {
                    radius: 0,
                    fill: 'black',
                    stroke: root.interfaceColors.get('background'),
                    tooltipText: '6개월 뒤 예상 진도',
                    tooltipY: isMobile ? 30 : 0,
                    tooltipX: isMobile ? 51 : 0,
                    showTooltipOn: 'always',
                    tooltip: am5.Tooltip.new(root, {}),
                }),
            });
        });
    } else {
        series1.bullets.push(function () {
            return am5.Bullet.new(root, {
                sprite: am5.Circle.new(root, {
                    radius: isMobile ? 6 : 7,
                    fill: '#ccc',
                    text: "[fontWeight:700]{valueYWorking.formatNumber('#.')}%",
                    populateText: true,
                    fontSize: '2vmin',
                }),
            });
        });
        const legend = chart.children.unshift(
            am5.Legend.new(root, {
                nameField: 'name',
                fillField: 'color',
                strokeField: 'color',
                centerX: am5.percent(10),
                // 레전드 위치 조정
                x: isMobile ? am5.percent(37) : am5.percent(45),
                y: am5.percent(-18),
            }),
        );
        legend.data.setAll([
            {
                name: '현재 성취/출제율',
                color: '#18b73f',
            },
            {
                name: '이전 성취/출제율',
                color: am5.color('#ccc'),
                // '#e2e2e2','#A0A0A0'
            },
        ]);
    }
    series1.data.setAll(props.chartData);
    series1.appear(1000);
    // }

    // Add series2 (현재 차트)
    const series2 = chart.series.push(
        am5xy.LineSeries.new(root, {
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: 'value2',
            categoryXField: 'category',
            stroke: '#18b73f',
            maskBullets: false,
        }),
    );
    series2.strokes.template.setAll({
        // strokeDasharray: [2, 2],
        strokeWidth: isMobile ? 2 : 3,
    });
    //cicle
    series2.bullets.push(function () {
        return am5.Bullet.new(root, {
            sprite: am5.Circle.new(root, {
                radius: isMobile ? 6 : 7,
                fill: '#18b73f',
            }),
        });
    });
    //퍼센트 표시
    series2.bullets.push(function () {
        return am5.Bullet.new(root, {
            // locationY: 0.0,
            locationY: 1.0,
            sprite: am5.Label.new(root, {
                text: "[fontWeight:700]{valueYWorking.formatNumber('#.')}%",
                // fill: root.interfaceColors.get("alternativeText"),
                centerY: am5.p100,
                centerX: am5.p50,
                populateText: true,
                fill: '#18b73f',
                fontSize: '2vmin',
            }),
        });
    });

    // Add cursor 툴팁 ex3
    // chart.set(
    //     'cursor',
    //     am5xy.XYCursor.new(root, {
    //         xAxis: xAxis,
    //     }),
    // );
    // xAxis.set(
    //     'tooltip',
    //     am5.Tooltip.new(root, {
    //         themeTags: ['axis'],
    //     }),
    // );
    // yAxis.set(
    //     'tooltip',
    //     am5.Tooltip.new(root, {
    //         themeTags: ['axis'],
    //     }),
    // );

    // Add grid style
    const myTheme = am5.Theme.new(root);
    myTheme.rule('Grid').setAll({
        // stroke: am5.color('#e2e2e2'),
        // strokeWidth: 5,
    });
    root.setThemes([myTheme]);

    series2.data.setAll(props.chartData);
    xAxis.data.setAll(props.chartData);

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    series2.appear(1000);
    chart.appear(1000, 100);
});

onUnmounted(() => {
    if (root) {
        root.dispose();
    }
});
</script>
<!-- scss 추가 -->
<style scoped lang="scss">
@media print {
    //pc 쿼리 추가
    @media all and (min-width: 1024px) {
        .chart {
            ::v-deep > div {
                display: flex;
                justify-content: center;
            }
            ::v-deep canvas {
                width: 110% !important;
                height: 110% !important;
                top: 60% !important;
                left: 50% !important;
                transform: translate(-50%, -50%);
            }
        }
    }
    //tablet 쿼리 추가
    @media all and (max-width: 1023px) {
        .chart {
            ::v-deep > div {
                display: flex;
                justify-content: center;
            }
            ::v-deep canvas {
                width: 110% !important;
                height: 120% !important;
                top: 50% !important;
                left: 50% !important;
                transform: translate(-50%, -50%);
            }
        }
    }
}
</style>
